import type { Diagnostic } from '@tailorcast/shared-types';

interface DiagnosticViewProps {
  diagnostic: Diagnostic;
}

export function DiagnosticView({ diagnostic }: DiagnosticViewProps) {
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-3 text-sm">
        <div>
          <span className="text-gray-500">Total products:</span>{' '}
          <span className="font-medium">{diagnostic.totalProducts}</span>
        </div>
        <div>
          <span className="text-gray-500">Matching:</span>{' '}
          <span className="font-medium">{diagnostic.matchingProducts}</span>
        </div>
        <div>
          <span className="text-gray-500">Avg score:</span>{' '}
          <span className="font-medium">{diagnostic.currentMetrics.avgScore.toFixed(1)}</span>
        </div>
      </div>

      {Object.entries(diagnostic.issueBreakdown).length > 0 && (
        <div>
          <h4 className="text-sm font-medium text-gray-700 mb-1">Issues Found</h4>
          <div className="space-y-1">
            {Object.entries(diagnostic.issueBreakdown).map(([key, count]) => (
              <div key={key} className="flex justify-between text-sm">
                <span className="text-gray-600 capitalize">
                  {key.replace(/([A-Z])/g, ' $1').trim()}
                </span>
                <span className="font-medium">{count}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      <p className="text-sm text-gray-600">{diagnostic.problemMap}</p>
    </div>
  );
}
